import React from "react";
import PropTypes from "prop-types";

import FileItem from "./item";

class FileItems extends React.Component {
    render() {
        const selected = this.props.selected || [];

        return (
            <>
                {(this.props.items || []).map((item) => (
                    <FileItem
                        key={`${item.type}_${item.uuid}`}
                        item={item}
                        checked={selected.includes(item.uuid)}
                        onOpen={this.props.onOpen}
                        onSelect={this.props.onSelect}
                        onContextMenu={this.props.onContextMenu}
                    />
                ))}
            </>
        );
    }
}

FileItems.propTypes = {
    items: PropTypes.array,
    selected: PropTypes.array,
    onOpen: PropTypes.func,
    onSelect: PropTypes.func,
    onContextMenu: PropTypes.func
};

FileItems.defaultProps = {
    items: [],
    selected: []
};

export default FileItems;